import { ClassDomainService } from './domain';
import { ClassChildFactory } from './entity/classChildFactory';

import type { ClassChildIRepository } from './entity/classChildIRepository';
import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { Logger } from '@/infra/logger';
import type { ClassChildJson, ClassChildJsonPvt } from '@/types/domain/class/entities/classChildEntity';

/**
 * クラスアプリケーションサービス
 */
export class ClassApplicationService {
  private service!: ClassDomainService;

  private classChild = new ClassChildFactory();

  /**
   * Injection
   * @param childClassRepository childClassRepository
   * @param logger logger
   */
  public inject(
    childClassRepository: ClassChildIRepository,
    logger: Logger,
  ) {
    this.service = new ClassDomainService(logger);
    this.service.inject(childClassRepository);
  }

  /**
   * getClassChildList
   * @returns items
   */
  async getClassChildList() {
    const items = await this.service.getClassChildList();
    return items;
  }

  /**
   * クラス子どもリストを更新する(Create)
   * @param classChildList リスト
   * @param payload 取得値
   * @returns 更新リスト
   */
  public createClassChildStore(
    classChildList: ClassChildJson[],
    payload: EntitySubscribeType,
    filter: ((json: ClassChildJsonPvt) => boolean) | undefined,
  ) {
    return this.service.createEntityStorePub(
      classChildList,
      payload,
      this.classChild,
      filter,
    );
  }

  /**
   * クラス子どもリストを更新する(Update)
   * @param classChildList リスト
   * @param payload 取得値
   * @returns 更新リスト
   */
  public updateClassChildStore(
    classChildList: ClassChildJson[],
    payload: EntitySubscribeType,
  ) {
    return this.service.updateEntityStorePub(
      classChildList,
      payload,
      this.classChild,
    );
  }

  /**
   * クラス子どもリストを更新する(Delete)
   * @param classChildList リスト
   * @param payload 取得値
   * @returns 更新リスト
   */
  public deleteClassChildStore(
    classChildList: ClassChildJson[],
    payload: DeleteOutputType,
  ) {
    return this.service.deleteEntityStorePub(
      classChildList,
      payload,
      this.classChild,
    );
  }
}
